import React, { useState, useRef } from 'react';
import Popover from 'react-bootstrap/Popover';
import Overlay from 'react-bootstrap/Overlay';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';

/**
 * @param {Array} pages - { header: String, body: Element }
 * @param String position - top, bottom, left, right
 * @
 *
 * Design System Teaching Bubble impelemnted with React Bootstrap Overlay and Popover
 *
 */
function TeachingBubble(_ref) {
  let {
    pages,
    position = 'bottom'
  } = _ref;
  const [show, setShow] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [target, setTarget] = useState(null);
  const ref = useRef(null);
  const onClick = event => {
    setShow(!show);
    setTarget(event.target);
  };
  const onNextClick = () => {
    currentPage === pages.length - 1 ? setCurrentPage(0) : setCurrentPage(currentPage + 1);
  };
  const onCancelClick = () => {
    setShow(false);
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "info",
    onClick: onClick
  }, "Help"), /*#__PURE__*/React.createElement(Overlay, {
    show: show,
    target: target,
    placement: position,
    container: ref.current,
    containerPadding: 40
  }, /*#__PURE__*/React.createElement(Popover, {
    id: "teaching-bubble-container"
  }, /*#__PURE__*/React.createElement(Popover.Header, {
    className: "pb-2",
    as: "h1"
  }, /*#__PURE__*/React.createElement("h3", null, pages[currentPage].header)), /*#__PURE__*/React.createElement(Popover.Body, null, /*#__PURE__*/React.createElement("div", null, pages[currentPage].body), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between mt-4"
  }, /*#__PURE__*/React.createElement("div", null, pages.length > 1 ? `${currentPage + 1} of ${pages.length}` : ''), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    className: "me-2",
    variant: "outline-light",
    onClick: () => onCancelClick()
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "outline-light",
    onClick: () => onNextClick()
  }, "Next")))))));
}
export default TeachingBubble;